import { render, staticRenderFns } from "./cg-event-link.vue?vue&type=template&id=0dd2a180&scoped=true"
import script from "./cg-event-link.vue?vue&type=script&lang=js"
export * from "./cg-event-link.vue?vue&type=script&lang=js"
import style0 from "./cg-event-link.vue?vue&type=style&index=0&id=0dd2a180&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dd2a180",
  null
  
)

export default component.exports